const TEMPO_MUSCULACAO = [
  {
      label: 'Sedentário, voltando ou faço outro tipo de atividade física atualmente',
      value: 1
  },
  {
      label: 'Pratico a menos de 6 meses',
      value: 2
  },
  {
      label: 'Pratico a mais de 6 meses',
      value: 3
  }
];
export default TEMPO_MUSCULACAO;



// WEBPACK FOOTER //
// ./src/data/TempoMusculacao.js